import type { PageSkeletonVariant } from './PageSkeleton'

const GRID_PATHS = [
    '/works',
    '/work/launchbrief',
    '/work/editions',
    '/work/salessheet',
    '/work/activities',
    '/concepts',
    '/contacts',
    '/contacts/lists',
    '/assets',
    '/bundle/list',
    '/series/list',
    '/mydownloads',
    '/royalty/agreements',
    '/royalty/statements',
]

const DETAIL_PREFIXES = [
    '/work/',
    '/concept/',
    '/contact/',
    '/assets/',
    '/user/',
    '/book/',
    '/series/list/',
    '/royalty/agreement/',
    '/administration/users/',
    '/administration/clients/',
]

const TABS_PREFIXES = [
    '/royalty',
    '/admin',
    '/administration',
    '/imports',
    '/integrations',
    '/metadata',
    '/bundle',
]

export function pageSkeletonVariant(pathname: string): PageSkeletonVariant {
    const path = pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname

    if (GRID_PATHS.includes(path)) return 'grid'
    if (DETAIL_PREFIXES.some((prefix) => path.startsWith(prefix))) return 'detail'
    if (TABS_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))) {
        return 'tabs'
    }

    return 'section'
}
